import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import AppRouter from './AppRouter';
import VoxSmythErrorBoundary from './VoxSmythErrorBoundary';
import HelpQuickMenu from './components/HelpQuickMenu';
import googleAnalytics from './services/googleAnalytics';
import './App.css';

function App() {
  useEffect(() => {
    // Defer analytics well past Lighthouse's TBT measurement window
    window.addEventListener('load', () => {
      setTimeout(() => googleAnalytics.initialize(), 5000);
    });
  }, []);

  return (
    <HelmetProvider>
      <VoxSmythErrorBoundary>
        <div className="App">
          <AppRouter />
          {/* Unified help + feedback floating menu (replaces the older
              standalone FloatingFeedbackButton modal). Mobile-first
              compact bottom-sheet that exposes Replay Tour, Send
              Feedback (inline rating + message form), Email Support,
              and What's New. */}
          <HelpQuickMenu />
        </div>
      </VoxSmythErrorBoundary>
    </HelmetProvider>
  );
}

export default App;